"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERNAL_HREF_REGEX = exports.cleanupQuery = exports.routerUrl = void 0;
const utils_1 = require("@obvio/utils");
const route_regex_1 = require("next/dist/shared/lib/router/utils/route-regex");
const href_1 = require("./href");
const locales_1 = require("./locales");
const constants_1 = require("../constants");
const env_1 = require("../env");
function routerUrl(url, locale) {
    let route = normalizeHref(url || '/');
    if (route.startsWith('/')) {
        route = (0, locales_1.localizePathname)(route, locale);
        const href = new href_1.Href(route);
        const isLocaleDomain = env_1.STAGE === 'production' &&
            locale !== constants_1.DEFAULT_LANG &&
            locale in constants_1.LOCALE_DOMAINS;
        const as = new href_1.Href(isLocaleDomain
            ? href.toString().replace(new RegExp(`^/${locale}/?`, 'u'), '/')
            : href.toString());
        if (env_1.IS_SERVER || !window.__BUILD_MANIFEST) {
            return [href.toString(), as.toString()];
        }
        const { __rewrites, sortedPages } = window.__BUILD_MANIFEST;
        const rewrite = (0, locales_1.resolveRewrite)(route, __rewrites, sortedPages);
        if (rewrite) {
            href.pathname = rewrite.href;
            href.addParams(rewrite.pathParams);
            as.removeParams(...Object.keys(rewrite.pathParams));
            return [href.toString(), as.toString()];
        }
        const page = sortedPages.find((pattern) => (0, locales_1.matchRoute)(route, pattern));
        if (page) {
            href.pathname = page;
            const params = (0, locales_1.getPathParams)(route, page);
            href.addParams(params);
            as.removeParams(...Object.keys(params));
            return [href.toString(), as.toString()];
        }
        return [href.toString(), undefined];
    }
    return [route, undefined];
}
exports.routerUrl = routerUrl;
function cleanupQuery(query, page) {
    return (0, utils_1.omit)(query, ...Object.keys((0, route_regex_1.getRouteRegex)(page).groups));
}
exports.cleanupQuery = cleanupQuery;
exports.INTERNAL_HREF_REGEX = /^(\/|#)/u;
function normalizeHref(href) {
    const string = String(href || '#');
    const homeUrl = (0, env_1.getHomeUrl)();
    return !string.startsWith('#') && new URL(string, homeUrl).origin === homeUrl
        ? new href_1.Href(string).toString()
        : string;
}
